export const DICTIONARY_API_ADDITIONAL_JOBS_CONTROLLER_END_POINTS = {
  CONTROLLER_PATH: "settings/additional-jobs",
};
